import { PDFDocument } from 'pdf-lib';

// Accepts an array of File objects (image/png or jpeg) and returns a single PDF File
export const convertImagesToPdf = async (imageFiles) => {
  const pdfDoc = await PDFDocument.create();

  const addImagePage = async (file) => {
    const bytes = await file.arrayBuffer();
    let img;
    try {
      if ((file.type || '').includes('png')) {
        img = await pdfDoc.embedPng(bytes);
      } else {
        img = await pdfDoc.embedJpg(bytes);
      }
    } catch {
      img = await pdfDoc.embedPng(bytes);
    }
    const page = pdfDoc.addPage([img.width, img.height]);
    page.drawImage(img, { x: 0, y: 0, width: img.width, height: img.height });
  };

  for (const f of imageFiles) {
    await addImagePage(f);
  }

  const pdfBytes = await pdfDoc.save();
  const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
  const pdfFile = new File([pdfBlob], `scan_${Date.now()}.pdf`, { type: 'application/pdf' });
  return pdfFile;
};


